import { fetchResultFromProcessors } from './processor-util';
import { processFolderSizeLimitError } from './upload-asset-limit-error';
import { getAssetUploadError } from './upload-asset-error';

const processFolderSizeLimitErrors = ({
  folderCreationErrors, aid, logger, i18n,
}) => {
  const folderLimitResult = processFolderSizeLimitError({ errorList: folderCreationErrors, aid, logger });
  if (folderLimitResult) {
    const { limit: folderLimit } = folderLimitResult;
    const warnMessage = _TL_('Failed to create one or more folders because your account has exceeded the {{value}}-folder limit. Please remove folders and try again.');

    return i18n.getString(warnMessage, { value: folderLimit });
  }

  return '';
};

const processAssetErrors = ({
  assetUploadErrors, i18n, filePickerI18n, aid, logger,
}) => getAssetUploadError({
  uploadErrorCodeArr: assetUploadErrors,
  i18n,
  filePickerI18n,
  aid,
  logger,
  disableGenericMessage: true,
});

export const getFolderUploadError = ({
  folderCreationErrors,
  assetUploadErrors,
  i18n,
  filePickerI18n,
  aid,
  logger,
}) => {
  const result = fetchResultFromProcessors({
    processors: [
      processFolderSizeLimitErrors,
      processAssetErrors,
    ],
    options: {
      folderCreationErrors,
      assetUploadErrors,
      i18n,
      filePickerI18n,
      aid,
      logger,
    },
  });

  if (result) {
    return result;
  }

  let genericErrorMessage;
  if (folderCreationErrors.length > 0) {
    if (assetUploadErrors.length > 0) {
      genericErrorMessage = _TL_('One or more folders or assets within folders failed to upload.');
    } else {
      genericErrorMessage = _TL_('One or more folders failed to upload.');
    }
  } else {
    genericErrorMessage = _TL_('One or more assets within your folders failed to upload.');
  }

  return i18n.getString(genericErrorMessage);
};
